<template>
  <el-form ref="ruleForm" :model="item" label-position="left" label-width="160px">
    <video-item ref="video" isOutstream></video-item>
  </el-form>
</template>

<script>
import MixCreativeForm from "@/components/mixins/creativeForm";
export default {
  data() {
    return {
      item: {},
    };
  },
  mixins: [MixCreativeForm],
  methods: {
    setData(row) {
      this.$refs.video.setData(row);
    },
    async getData(setObj) {
      return await this.$refs.video.getData(setObj, 640, 360);
    },
  },
};
</script>

<style></style>
